import { Component, Input, ViewContainerRef, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'anon-alert',
  template: `
      <span><ng-content></ng-content></span>
      <button mat-icon-button *ngIf="dismissible" (click)="removeAlert()"><mat-icon class="material-icons-round">close</mat-icon></button>
  `,
  styles: [`
    .alert-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: -webkit-fill-available;

      border-radius: 1rem;
      padding: 1rem;

      background-color: #c1c1c1;
    }
    // todo: use angular material theme
    .alert-container.info { background-color: #d9e7cb; }
    .alert-container.warning { background-color: #ffdea6; }
    .alert-container.danger { background-color: #ff9d9c; }
  `],
  inputs: ['status', 'element'],
  host: {
    class: 'alert-container',
    /* assign alert status class */
    '[class.info]': 'status === "info"',
    '[class.warning]': 'status === "warning"',
    '[class.danger]': 'status === "danger"'
  },
  encapsulation: ViewEncapsulation.None,
})
export class AlertComponent {
  /** whether the alert will show the close icon to dismiss the alert */
  @Input()
  dismissible: boolean = false;

  /** development component
   * initially used to indicate pages that need more work */
  status: 'basic' | 'info' | 'warning' | 'danger' = 'basic';

  constructor(public viewContainerRef: ViewContainerRef) {}

  removeAlert() {
    console.log(this.viewContainerRef.element.nativeElement);
    this.viewContainerRef.element.nativeElement.remove();
  }
}
